import {useQuery, gql} from "@apollo/client";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getResortDetails($hapimagResortId: Int!){
    resortCollection(where: {hapimagResortId: $hapimagResortId}){
        items{
            pictureSearchByLocation{
                url
            }
        }
    }

    apartmentCategoryCollection(where: {resort: {hapimagResortId: $hapimagResortId}}){
        items{
            apartmentCategory{
                code
            },
            imagesCollection{
                items{
                    url
                }
            }
        }
    }
}`;

export const useResortImages = (hapimagResortId) => {
    const {logger} = useLogger();
    const { loading, error, data } = useQuery(QUERY, {
        variables: { hapimagResortId },
        errorPolicy: "all"
    });
    const resortImages = data;

    if (error?.message) {
        logger(error?.message, "error", "useResortImages", error?.stack);
    }

    return {
        resortImages,
        loading,
        error
    };
};
